import paths from 'redux/paths';
import client from 'helpers/client';
import mvpAuth from "../../../helpers/mvpAuth";
import * as types from "../actionTypes";
import {
    FETCH_ACCEPT_REJECT_SESSION, FETCH_ACCEPT_REJECT_SESSION_FAILED,
    FETCH_CREATE_SESSION,
    FETCH_CREATE_SESSION_FAILED,
    FETCH_CREATE_SESSION_SUCCESS, FETCH_HISTORY_SESSIONS, FETCH_HISTORY_TRANSACTIONS,
    FETCH_REGISTER_SESSION, FETCH_REGISTER_SESSION_FAILED,
    FETCH_REMOVE_SESSION,
    FETCH_REMOVE_SESSION_FAILED,
    FETCH_REMOVE_SESSION_SUCCESS, FETCH_TRACKING_SESSION,
    FETCH_UPDATE_SESSION, FETCH_UPLOAD_FILE, FETCH_UPLOAD_FILE_FAILED, FETCH_VERIFY_JOIN_SESSION,
} from '../actionTypes';

// export const getSessionHistory = (limit, page) => {
// Khai báo hàm getSessionHistory
export const getSessionHistory = (limit, page) => async (dispatch) => {
  try {
    const data = await client.sendRequest({
      path: `/mvp/user-get-session-history?limit=${limit}&page=${page}`,
      method: 'GET',
      params: {},
      headers: mvpAuth.getHeaderForMvp(),
    });
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.message };
  }
};

